import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { Field } from 'formik';
import HdFormikTextField from '../../../../form/formik/components/text-field/HdFormikTextField';
import HdFormControl from '../../../../form/components/form-control/HdFormControl';
import HdFormikPasswordField from '../../../../form/formik/components/password-field/HdFormikPasswordField';
import HdFormikDropDown from '../../../../form/formik/components/dropdown/HdFormikDropDown';
import { ConfigByType } from '../configByType';
import CustomOptionWithSubtext from '../../../../dropdown/components/dropdown-custom-options/CustomOptionWithSubtext';
import HdFormikSwitchWrapper from '../../../../form/formik/components/switch-wrapper/HdFormikSwitchWrapper';
import { ConfigDestinationTypeBaseProps } from '../interface';

export default function S3({ maskSecretFields }: ConfigDestinationTypeBaseProps) {
  const memoizedGetRegions = useMemo(ConfigByType.S3.regionList, []);
  const memoizedGetFileFormats = useMemo(ConfigByType.S3.fileFormatList, []);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='awsAccessKey'
              label='Access Key ID'
              required
              component={HdFormikTextField}
            />
          </HdFormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='awsSecretAccessKey'
              label='Secret Access Key'
              required
              masked={maskSecretFields}
              component={HdFormikPasswordField}
            />
          </HdFormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field name='bucket' label='Bucket Name' required component={HdFormikTextField} />
          </HdFormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field name='prefix' label='Prefix' component={HdFormikTextField} />
          </HdFormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='bucketRegion'
              label='Bucket Region'
              required
              idAccessor='value'
              options={memoizedGetRegions}
              component={HdFormikDropDown}
              CustomOption={CustomOptionWithSubtext}
            />
          </HdFormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='fileFormat'
              label='File Format'
              required
              idAccessor='value'
              options={memoizedGetFileFormats}
              component={HdFormikDropDown}
            />
          </HdFormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2} className='mb-7'>
        <Grid item xs={12} md={12}>
          <HdFormControl>
            <HdFormikSwitchWrapper fieldName='gzip' label='Should files be GZipped?' />
          </HdFormControl>
        </Grid>
      </Grid>
    </>
  );
}
